/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindFileQueryResponse } from './FindFileQueryResponse';
import {
    FindFileQueryResponseFromJSON,
    FindFileQueryResponseFromJSONTyped,
    FindFileQueryResponseToJSON,
} from './FindFileQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListFileQueryResponse
 */
export interface ListFileQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListFileQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindFileQueryResponse>}
     * @memberof ListFileQueryResponse
     */
    data: Array<FindFileQueryResponse>;
}

/**
 * Check if a given object implements the ListFileQueryResponse interface.
 */
export function instanceOfListFileQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListFileQueryResponseFromJSON(json: any): ListFileQueryResponse {
    return ListFileQueryResponseFromJSONTyped(json, false);
}

export function ListFileQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListFileQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindFileQueryResponseFromJSON)),
    };
}

export function ListFileQueryResponseToJSON(value?: ListFileQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindFileQueryResponseToJSON)),
    };
}

